import React from 'react';

const KeyboardDoubleArrowRight = () => (
  <svg
    focusable="false"
    aria-hidden="true"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.41 6 5 7.41 9.58 12 5 16.59 6.41 18l6-6z" />
    <path d="m13 6-1.41 1.41L16.17 12l-4.58 4.59L13 18l6-6z" />
  </svg>
);

export default KeyboardDoubleArrowRight;
